import { useFormErrorBaseHandler, type UseFormErrorHandlerOptions } from '@capsicum/common';

import { useScrollToElement } from '../helpers/useScrollToElement';

import type { FieldValues, UseFormReturn } from 'react-hook-form';

export const useFormErrorHandler = <FormShape extends FieldValues>(
	form: UseFormReturn<FormShape, unknown, FormShape>,
	options: UseFormErrorHandlerOptions<FormShape> = {}
) => {
	const { scrollToElementByName } = useScrollToElement();

	const { onError } = useFormErrorBaseHandler<FormShape>(form, {
		...options,
		scrollTo: scrollToElementByName
	});

	return { onError };
};
